<template>
  <span>正在加载中...</span>
</template>

<script>
export default {
  name: "Share",
  created() {
    this.$router.push({
      path: '/share/' + this.$route.query.type.toLowerCase(),
      query: this.$route.query
    })
  }
}

</script>

<style scoped>

</style>
